import src from "IMAGE";
export default { src, width: 8147, height: 514, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAHElEQVR42mNgYGDwAmJfIHaB0iFAHADE7kDsCAAjcQJVgGdiKwAAAABJRU5ErkJggg=="};
